var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_36833",
    "data-name": "Group 36833",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "rgba(218,24,24,0.15)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7992",
    "data-name": "Path 7992",
    d: "M7.58,0,6.974,2.379,12.893,3.92,0,11.377l1.213,2.1L14.1,6.016l-1.614,5.9,2.363.66,2.73-9.97Z",
    transform: "translate(31.82 29.766) rotate(180)",
    fill: "#da1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedarrow);
export default __webpack_public_path__ + "static/media/redarrow.c7eea8bc1333f70c08715d3e232ae35e.svg";
export { ForwardRef as ReactComponent };